import { createSelector } from 'reselect';
import _get from 'lodash.get';

export const betSelector = ({ bet }) => bet;

export const placedBetSelector = createSelector(
    betSelector,
    ({ placedBetDetails }) => placedBetDetails || null,
);

export const placedBetBookmakerSelector = createSelector(
    placedBetSelector,
    placedBet => _get(placedBet, 'bets[0].bets[0].feed', null),
);



// WEBPACK FOOTER //
// /src/js/common/bet/bet.selectors.js